var modules_c05201b4 = {"storeButton":"Store_module_storeButton__358c0217","bgDark":"Store_module_bgDark__358c0217"};
import "../../../assets/DHdCuqUv.css";

export { modules_c05201b4 as default };
//# sourceMappingURL=Store.module.less.js.map
